import { AuthComponent } from "./components/auth/AuthComponent";
import { PublicHOC } from "./components/publicPortal/PublicHOC";
import { RightsHolderHoc } from "./components/rightsHolder/RightsHolderHoc";
import { UserSessionActivityHoc } from "./components/session/UserSessionActivityHoc";
import { PortalSwitchHoc } from "./components/shared/PortalSwitchHoc";
import {
  LayoutAuthors,
  LayoutBlankMedia,
  LayoutLicensees,
  LayoutPublic,
} from "./components/shared/components";
import { AvisContextProvider } from "./components/shared/context/AvisContextProvider";
import { ErrorBoundary } from "./components/shared/error/ErrorBoundary";
import { AvisNotificationHoc } from "./components/shared/notifications/AvisNotificationHoc";
import AvisRouterHoc from "./components/shared/router/AvisRouterHoc";
import { AcceptTermsHoc } from "./components/terms/AcceptTermsHoc";
import { avisRoutes } from "./data/avisRoutes";

function App() {
  return (
    <ErrorBoundary>
      <AvisContextProvider>
        <AvisNotificationHoc>
          <PortalSwitchHoc
            authors={
              <AuthComponent>
                <UserSessionActivityHoc>
                  <AcceptTermsHoc>
                    <AvisRouterHoc routes={avisRoutes}>
                      <RightsHolderHoc>
                        <LayoutAuthors />
                      </RightsHolderHoc>
                    </AvisRouterHoc>
                  </AcceptTermsHoc>
                </UserSessionActivityHoc>
              </AuthComponent>
            }
            licensees={
              <AuthComponent>
                <UserSessionActivityHoc>
                  <AcceptTermsHoc>
                    <AvisRouterHoc routes={avisRoutes}>
                      <LayoutLicensees />
                    </AvisRouterHoc>
                  </AcceptTermsHoc>
                </UserSessionActivityHoc>
              </AuthComponent>
            }
            blankMedia={
              <AuthComponent>
                <UserSessionActivityHoc>
                  <AcceptTermsHoc>
                    <AvisRouterHoc routes={avisRoutes}>
                      <LayoutBlankMedia />
                    </AvisRouterHoc>
                  </AcceptTermsHoc>
                </UserSessionActivityHoc>
              </AuthComponent>
            }
            publicPortal={
              <PublicHOC>
                <AvisRouterHoc routes={avisRoutes}>
                  <LayoutPublic className="public-layout" />
                </AvisRouterHoc>
              </PublicHOC>
            }
          />
        </AvisNotificationHoc>
      </AvisContextProvider>
    </ErrorBoundary>
  );
}

export default App;
